import React, {useEffect} from 'react'
import {Button} from "semantic-ui-react";
import useSound from 'use-sound'



function DialogButton(props) {

    return (
        <div>
            <Button size={props.size} color={props.color} circular onClick={() => {props.file.play(); props.showResponse(props.id)}} className={props.style}>
                <h5 style={{color: 'black'}}>
                    {props.name}
                </h5>
            </Button>
        </div>
    )
}

DialogButton.defaultProps = {
    showResponse: () => {
        console.log('')
    },
    size: 'medium',
    file: 'sa1.mp3',
    fontColor: ''

};

export default DialogButton
